import source from '../../../../docs/MAX/src/consts/budgetContingencyFactors.json'

import { SelectionOption } from '../core/types/chat.types'

const budgetContingencyFactors = source as SelectionOption[]

export default budgetContingencyFactors
